import { ApiRole } from '@/rennovation/planning-view/types/api/roles-response';

export class PermissionService {
	constructor() {}

	private roleMap: Map<string, string[]> = new Map();

	/**
	 * Called by the Vuex Action after fetching /api/roles
	 */
	public initialize(roles: ApiRole[]): void {
		this.roleMap.clear();
		roles.forEach((role) => {
			const id = role.id || role._id;
			this.roleMap.set(id, role.permissions || []);
		});
	}

	/**
	 * The "Bridge" logic that handles the currently incompatible backend shapes
	 */
	public resolvePermissions(roles: (string | { permissions: string[] })[]): Set<string> {
		const permissions = new Set<string>();

		roles.forEach((role) => {
			if (typeof role === 'object' && role !== null) {
				// Driver format: Full object provided
				role.permissions?.forEach((p) => permissions.add(p));
			} else if (typeof role === 'string') {
				// Supervisor/Lite format: Only ID provided
				const cachedPermissions = this.roleMap.get(role);
				cachedPermissions?.forEach((p) => permissions.add(p));
			}
		});

		return permissions;
	}
}
